import Env from '@lib/Env';

import { OauthClient, ApiConnector } from '@lib/@m7/oauth2-client';

export const OauthClientInstance = new OauthClient({
    server: Env.services.auth.server,
    client_id: Env.services.auth.client_id,
    redirect_uri: Env.services.auth.redirect_uri,
    token_storage_key: 'vc.oauth.token',
    proxy: Env.services.auth.proxy,
});

export const ApiConnectorInstance = new ApiConnector(
    {
        services: {
            local: {
                baseURL: Env.services.local.baseURL,
            },
            oldapi: {
                baseURL: Env.services.oldapi.baseURL,
            },
            storage: {
                baseURL: Env.services.storage.baseURL,
            },
            admin: {
                baseURL: Env.services.admin.baseURL,
            },
        },
        auth: {
            service: 'local',
            login: 'users/login',
            logout: 'users/logout',
            refreshToken: 'users/refresh-access-token',
            passwordlessRequestCode: 'users/passwordless-code',
            whoAmI: 'users/whoami',
        },
    },
    OauthClientInstance,
    Env.log
);
